var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      staticClass: "vModal vModalDefault",
      class: _vm.$style.dialog,
      on: { cancel: _vm.$formCancelHandler, submit: _vm.$formSubmitHandler },
    },
    [
      _c(
        "div",
        { class: _vm.$style.header, attrs: { slot: "header" }, slot: "header" },
        [
          _c(
            "i",
            { staticClass: "material-icons", class: _vm.$style.warning },
            [_vm._v("info_outline")]
          ),
          _c("div", { class: _vm.$style.texts }, [
            _c("div", [_vm._v(_vm._s(_vm.title))]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultBody hotel-directory",
          attrs: { slot: "body" },
          slot: "body",
        },
        [_c("div", [_vm._v(_vm._s(_vm.subTitle))])]
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultFooter",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _vm.buttonText
            ? _c(
                "button",
                {
                  staticClass: "rbButton mainButton",
                  class: _vm.$style.mainButton,
                },
                [
                  _c("i", { staticClass: "material-icons" }, [_vm._v("check")]),
                  _vm._v(" " + _vm._s(_vm.buttonText) + " "),
                ]
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }